// @mui material components
import { createTheme } from '@mui/material/styles'

//  React base styles
import colors from 'assets/theme-secondary/base/colors'
import breakpoints from 'assets/theme-secondary/base/breakpoints'
import typography from 'assets/theme-secondary/base/typography'
import boxShadows from 'assets/theme-secondary/base/boxShadows'
import borders from 'assets/theme-secondary/base/borders'
import globals from 'assets/theme-secondary/base/globals'

//  React helper functions
import boxShadow from 'assets/theme-secondary/functions/boxShadow'
import hexToRgb from 'assets/theme-secondary/functions/hexToRgb'
import linearGradient from 'assets/theme-secondary/functions/linearGradient'
import pxToRem from 'assets/theme-secondary/functions/pxToRem'
import rgba from 'assets/theme-secondary/functions/rgba'

//  React components base styles for @mui material components
import sidenav from 'assets/theme-secondary/components/sidenav'
import list from 'assets/theme-secondary/components/list'
import listItem from 'assets/theme-secondary/components/list/listItem'
import listItemText from 'assets/theme-secondary/components/list/listItemText'
import card from 'assets/theme-secondary/components/card'
import cardMedia from 'assets/theme-secondary/components/card/cardMedia'
import cardContent from 'assets/theme-secondary/components/card/cardContent'
import button from 'assets/theme-secondary/components/button'
import iconButton from 'assets/theme-secondary/components/iconButton'
import input from 'assets/theme-secondary/components/form/input'
import inputLabel from 'assets/theme-secondary/components/form/inputLabel'
import inputOutlined from 'assets/theme-secondary/components/form/inputOutlined'
import textField from 'assets/theme-secondary/components/form/textField'
import menu from 'assets/theme-secondary/components/menu'
import menuItem from 'assets/theme-secondary/components/menu/menuItem'
import switchButton from 'assets/theme-secondary/components/form/switchButton'
import divider from 'assets/theme-secondary/components/divider'
import tableContainer from 'assets/theme-secondary/components/table/tableContainer'
import tableHead from 'assets/theme-secondary/components/table/tableHead'
import tableCell from 'assets/theme-secondary/components/table/tableCell'
import linearProgress from 'assets/theme-secondary/components/linearProgress'
import breadcrumbs from 'assets/theme-secondary/components/breadcrumbs'
import slider from 'assets/theme-secondary/components/slider'
import avatar from 'assets/theme-secondary/components/avatar'
import tooltip from 'assets/theme-secondary/components/tooltip'
import appBar from 'assets/theme-secondary/components/appBar'
import tabs from 'assets/theme-secondary/components/tabs'
import tab from 'assets/theme-secondary/components/tabs/tab'
import stepper from 'assets/theme-secondary/components/stepper'
import step from 'assets/theme-secondary/components/stepper/step'
import stepConnector from 'assets/theme-secondary/components/stepper/stepConnector'
import stepLabel from 'assets/theme-secondary/components/stepper/stepLabel'
import stepIcon from 'assets/theme-secondary/components/stepper/stepIcon'
import select from 'assets/theme-secondary/components/form/select'
import formControlLabel from 'assets/theme-secondary/components/form/formControlLabel'
import formLabel from 'assets/theme-secondary/components/form/formLabel'
import checkbox from 'assets/theme-secondary/components/form/checkbox'
import radio from 'assets/theme-secondary/components/form/radio'
import autocomplete from 'assets/theme-secondary/components/form/autocomplete'
import container from 'assets/theme-secondary/components/container'
import popover from 'assets/theme-secondary/components/popover'
import buttonBase from 'assets/theme-secondary/components/buttonBase'
import icon from 'assets/theme-secondary/components/icon'
import svgIcon from 'assets/theme-secondary/components/svgIcon'
import link from 'assets/theme-secondary/components/link'
import dialog from 'assets/theme-secondary/components/dialog'
import dialogTitle from 'assets/theme-secondary/components/dialog/dialogTitle'
import dialogContent from 'assets/theme-secondary/components/dialog/dialogContent'
import dialogContentText from 'assets/theme-secondary/components/dialog/dialogContentText'
import dialogActions from 'assets/theme-secondary/components/dialog/dialogActions'

export default createTheme({
  breakpoints: { ...breakpoints },
  palette: { ...colors },
  typography: { ...typography },
  boxShadows: { ...boxShadows },
  borders: { ...borders },
  functions: {
    boxShadow,
    hexToRgb,
    linearGradient,
    pxToRem,
    rgba
  },

  components: {
    MuiCssBaseline: {
      styleOverrides: {
        ...globals,
        ...container
      }
    },
    MuiDrawer: { ...sidenav },
    MuiList: { ...list },
    MuiListItem: { ...listItem },
    MuiListItemText: { ...listItemText },
    MuiCard: { ...card },
    MuiCardMedia: { ...cardMedia },
    MuiCardContent: { ...cardContent },
    MuiButton: { ...button },
    MuiIconButton: { ...iconButton },
    MuiInput: { ...input },
    MuiInputLabel: { ...inputLabel },
    MuiOutlinedInput: { ...inputOutlined },
    MuiTextField: { ...textField },
    MuiMenu: { ...menu },
    MuiMenuItem: { ...menuItem },
    MuiSwitch: { ...switchButton },
    MuiDivider: { ...divider },
    MuiTableContainer: { ...tableContainer },
    MuiTableHead: { ...tableHead },
    MuiTableCell: { ...tableCell },
    MuiLinearProgress: { ...linearProgress },
    MuiBreadcrumbs: { ...breadcrumbs },
    MuiSlider: { ...slider },
    MuiAvatar: { ...avatar },
    MuiTooltip: { ...tooltip },
    MuiAppBar: { ...appBar },
    MuiTabs: { ...tabs },
    MuiTab: { ...tab },
    MuiStepper: { ...stepper },
    MuiStep: { ...step },
    MuiStepConnector: { ...stepConnector },
    MuiStepLabel: { ...stepLabel },
    MuiStepIcon: { ...stepIcon },
    MuiSelect: { ...select },
    MuiFormControlLabel: { ...formControlLabel },
    MuiFormLabel: { ...formLabel },
    MuiCheckbox: { ...checkbox },
    MuiRadio: { ...radio },
    MuiAutocomplete: { ...autocomplete },
    MuiPopover: { ...popover },
    MuiButtonBase: { ...buttonBase },
    MuiIcon: { ...icon },
    MuiSvgIcon: { ...svgIcon },
    MuiLink: { ...link },
    MuiDialog: { ...dialog },
    MuiDialogTitle: { ...dialogTitle },
    MuiDialogContent: { ...dialogContent },
    MuiDialogContentText: { ...dialogContentText },
    MuiDialogActions: { ...dialogActions }
  }
})
